var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from "react";
import { Select } from "@bolteu/kalep-react";
var valueMap = {
  "true": true,
  "false": false
};
export var BooleanSelectField = function BooleanSelectFieldComponent(_a) {
  var _b, _c, _d, _e;
  var onChange = _a.onChange,
    value = _a.value,
    validatorResults = _a.validatorResults,
    optionsProp = _a.options,
    isCompact = _a.compact,
    rest = __rest(_a, ["onChange", "value", "validatorResults", "options", "compact"]);
  var validationError = validatorResults === null || validatorResults === void 0 ? void 0 : validatorResults[0];
  var options = [{
    value: "undefined",
    title: (_b = optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp.undefined) !== null && _b !== void 0 ? _b : "\xA0"
  }, {
    value: "true",
    title: (_c = optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp["true"]) !== null && _c !== void 0 ? _c : "True"
  }, {
    value: "false",
    title: (_d = optionsProp === null || optionsProp === void 0 ? void 0 : optionsProp["false"]) !== null && _d !== void 0 ? _d : "False"
  }];
  var handleChange = React.useCallback(function (newValue) {
    onChange({
      value: valueMap[String(newValue === null || newValue === void 0 ? void 0 : newValue.value)]
    });
  }, [onChange]);
  var label = (_e = rest.label) !== null && _e !== void 0 ? _e : rest.name;
  return /*#__PURE__*/React.createElement(Select, Object.assign({
    fullWidth: true,
    label: label,
    error: !!validationError,
    onChange: handleChange,
    value: options.find(function (option) {
      return option.value === String(value);
    }),
    helperText: validationError ? validationError.error : undefined,
    options: options,
    size: isCompact ? "sm" : undefined
  }, rest));
};